import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { LoadingSpinner } from '../../components/loadingSpinner/LoadingSpinner'
// import styles from './auth.module.scss'
import styles from '../../components/signup/signup.module.scss'
import { vendorSignUpWithActivationCode } from '../../features/authSlice'
import InputCustom from '../../components/atoms/input/InputCustom'
import AuthCommonCard from '../../components/molecules/AuthCommonCard'
import AuthCommonForm from '../../components/molecules/AuthCommonForm'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import { Typography } from '@mui/material'
import { validatePassword } from '../../util/passwordValidation'

const initialFormData = {
	firstName: '',
	lastName: '',
	email: '',
	password: '',
	confirmPassword: '',
	staffVerificationCode: '',
}

// TODO: needs to be redesigned

export const VendorStaffSignupPage = () => {
	const dispatch = useDispatch()

	const [formData, setFormData] = useState(initialFormData)
	const loading = useSelector((state) => state.auth.loading)
	const [passwordError, setPasswordError] = useState('')
	const [confirmPasswordError, setConfirmPasswordError] = useState('')

	const handleSubmit = (e) => {
		e.preventDefault()
		const error = validatePassword(formData.password)
		if (error) return setPasswordError(error)
		if (formData.password !== formData.confirmPassword)
			return setConfirmPasswordError('Passwords do not match')
		dispatch(vendorSignUpWithActivationCode(formData))
	}

	return (
		<AuthCommonCard className={styles.signInSection}>
			<AuthCommonForm
				title={'staff sign up'}
				subTitle={
					<>
						Already have an account?{' '}
						<Link to="/login" data-cy="go-to-sign-up">
							Sign in
						</Link>
					</>
				}
			>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.formGroup}>
						{/* <label htmlFor="First Name">First Name</label> */}
						<InputCustom
							placeholder="First Name"
							name="firstName"
							type="text"
							value={formData.firstName}
							autoFocus={true}
							setDataFunction={setFormData}
							data={formData}
							required={true}
						/>
					</div>

					<div className={styles.formGroup}>
						{/* <label htmlFor="Last Name">Last Name</label> */}
						<InputCustom
							placeholder="Last Name"
							name="lastName"
							type="text"
							value={formData.lastName}
							setDataFunction={setFormData}
							data={formData}
							required={true}
						/>
					</div>

					<div className={styles.formGroup}>
						{/* <label htmlFor="Email">Email</label> */}
						<InputCustom
							placeholder="Email"
							name="email"
							type="email"
							value={formData.email}
							setDataFunction={setFormData}
							data={formData}
							required={true}
						/>
					</div>

					<div className={styles.formGroup}>
						{/* <label htmlFor="Password">Password</label> */}
						<InputCustom
							placeholder="Password"
							name="password"
							type="password"
							enableShowPassword={true}
							value={formData.password}
							setDataFunction={setFormData}
							data={formData}
							required={true}
							eyeIcon={true}
							error={!!passwordError}
							changeFunction={() => {
								setPasswordError('')
								setConfirmPasswordError('')
							}}
						/>
						{passwordError && (
							<p className="text-error">{passwordError}</p>
						)}
					</div>

					<div className={styles.formGroup}>
						{/* <label htmlFor="Confirm Password">
							Confirm Password
							</label> */}
						<InputCustom
							placeholder="Confirm Password"
							name="confirmPassword"
							type="password"
							enableShowPassword={true}
							value={formData.confirmPassword}
							setDataFunction={setFormData}
							data={formData}
							required={true}
							eyeIcon={true}
							error={!!confirmPasswordError}
							changeFunction={() => setConfirmPasswordError('')}
						/>
						{confirmPasswordError && (
							<p className="text-error">{confirmPasswordError}</p>
						)}
					</div>

					<div className={styles.formGroup}>
						<InputCustom
							placeholder="Staff Activation Code"
							name="staffActivationCode"
							type="text"
							value={formData.staffActivationCode}
							setDataFunction={setFormData}
							data={formData}
							required={true}
						/>
					</div>
					<div className={` ${styles.signUpBtn}`}>
						<ButtonCustom
							variant="default"
							data-cy="submit"
							type="submit"
						>
							{loading ? (
								<LoadingSpinner size="10px" color="#333" />
							) : (
								'Sign Up'
							)}
						</ButtonCustom>
					</div>
				</form>
			</AuthCommonForm>
		</AuthCommonCard>
	)
}
